import type { ViewStyle } from "react-native";

/** Unterhalb dieser Containerbreite stehen die vier KPI-Kacheln in zwei Zeilen. */
export const KPI_BAR_NARROW_MAX = 480;

/**
 * Deckel der dichten Leiste. Die Trefferfläche bleibt `theme.table.rowTouch` (44).
 * Darüber hinaus darf die Kachel nicht wachsen.
 */
export const KPI_TILE_MAX_HEIGHT = 56;

/**
 * Breite der Kachel in der Leiste. `flexGrow` gilt nur für die Zeilenachse.
 * Unter 480 px erzwingt `minWidth` 46 % genau zwei Kacheln pro Zeile:
 * 48 % + 48 % plus Abstand schrumpft auf zwei Spalten, drei mal 46 % passen nicht.
 */
export function kpiTileFlex(containerWidth: number): ViewStyle {
  if (containerWidth > 0 && containerWidth < KPI_BAR_NARROW_MAX) {
    return {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: "48%",
      maxWidth: "48%",
      minWidth: "46%",
    };
  }
  return {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 0,
    maxWidth: "100%",
  };
}
